import { render, staticRenderFns } from "./Absent.vue?vue&type=template&id=a9d77622"
import script from "./Absent.vue?vue&type=script&lang=js"
export * from "./Absent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports